import { useCallback, useEffect, useRef, useState } from 'react'
import HttpStatus from 'http-status-codes'

import { config } from '../../../Init/Init'
import { tokenizer } from '../../../../services/utils'
import l10n from '../../../i18n/I18N'
import { usePlayerStore } from '../../../../services/store'
import { cryptoChannelDefaultData } from '../../cryptoPaymentConstants'
import { useCryptoPaymentDataModal } from '../../CryptoPaymentModalDataProvider'

export const useGetCryptoChannel = ({ setLoading, getCryptoCurrencyExchangeRate }) => {
  const playerStore = usePlayerStore()
  const accessToken = playerStore.use.accessToken()
  const playerUserId = playerStore.use.userId()

  const { selectedCurrency } = useCryptoPaymentDataModal()

  const [cryptoChannelData, setCryptoChannelData] = useState(cryptoChannelDefaultData)
  const [getChannelError, setGetChannelError] = useState()

  const isCryptoChannelDataInitRef = useRef(false)

  const getCryptoChannel = useCallback(
    selectedCurrency => {
      setLoading(true)

      const abortController = new AbortController()

      return fetch(
        config.paymentsUrl +
          tokenizer(config.getCoindirectChannelUrl, {
            '{userId}': playerUserId,
            '{currency}': selectedCurrency.currencyCode
          }),
        {
          signal: abortController.signal,
          mode: 'cors',
          headers: {
            Authorization: `Bearer ${accessToken.encryptedToken}`,
            'Content-Type': 'application/json'
          }
        }
      )
        .then(async response => {
          if (response.status === HttpStatus.OK) {
            const { address, alternatives, tag, redirectUrl } = await response.json()

            setCryptoChannelData({
              depositAddress: address,
              destinationTag: tag,
              bvnkHostedPageUrl: redirectUrl,
              alternatives: alternatives
            })
          } else {
            setGetChannelError(l10n.t['cryptopayment.channel.error'])
            setCryptoChannelData(cryptoChannelDefaultData)
            console.error('[CryptoPaymentModal] Could not get payment channel!')
          }
          setLoading(false)
          isCryptoChannelDataInitRef.current = true
        })
        .catch(e => {
          if (e.name === 'AbortError') return
          setLoading(false)
          setGetChannelError(l10n.t['cryptopayment.channel.error'])
          setCryptoChannelData(cryptoChannelDefaultData)
          console.error('[CryptoPaymentModal] Failed getting channel!', e)
        })
    },
    [accessToken.encryptedToken, setLoading, playerUserId]
  )

  useEffect(() => {
    if (selectedCurrency.currencyCode && !isCryptoChannelDataInitRef.current) {
      getCryptoChannel(selectedCurrency)
      getCryptoCurrencyExchangeRate({ from: config.baseFiatCurrency, to: selectedCurrency.currencyCode })
    }
  }, [selectedCurrency.currencyCode])

  return {
    getCryptoChannel,
    getChannelError,
    cryptoChannelData,
    setGetChannelError
  }
}
